module.exports = {
  themes:[
    'mdf'
  ],
  components:[
    'block-list',
    'block-std',
    'block-img',
    'block-flip',
    'btn-load',
    'accordionFW',
    'headerFW',
    'heroFW',
    'sliderFW',
    'select2FW',
    'foldingbox',
    'tabs',
    'goto',
    'modalFW',
    'guideline',
  ],
}


// WEBPACK FOOTER //
// ./framway.config.js